@if (bullets().length) {
<div class="carousel-dots"
     [class.ng-hide]="bullets().length <= 1"
     [style.--carousel-dots-number]="bullets().length">
    <div class="carousel-dots-inner"
         aria-label="Carousel pagination">
        @for (bullet of bullets(); track $index) {
        <button class="carousel-dot"
                [class.is-active]="index() === $index"
                type="button"
                [attr.aria-label]="'Carousel page ' + ($index + 1) + (index() === $index ? ' (Current slide)' : '')"
                (click)="slideTo($index)"></button>
        }
        <div class="carousel-dots-underbar"></div>
    </div>
</div>
}

<!-- hide swiper pagination -->
@if (paginationClass()) {
<div class="ng-hide"
     [ngClass]="paginationClass()"></div>
}